import * as React from "react";
import { Script } from "gatsby";

import * as styles from "../header/header.module.scss";

import ButtonCv from "../../atoms/link/button-cv";

/**
 * @type {Object} 「UI:Organisms - ヘッダー コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 *
 */

const Header = () => {
  return (
    <>
      <header className={`${styles.globalHeader}`}>
        <div className={`${styles.headerContainer}`}>
          <div className={`${styles.brandContainer}`}>
            <div className={`${styles.logo}`}>
              <h1>
                <figure>
                  <a href="/">
                    <img
                      src="https://images.ctfassets.net/mc0chld4pn1r/7bPBGwpCTIXNrQEndmCspB/d5f58fe9374a423a4ee03ab9e78c58d9/basixs-logo__1_.svg"
                      alt="BAsixs（ベーシックス）"
                      width="auto"
                      height="76"
                    />
                  </a>
                </figure>
              </h1>
            </div>
            <div className={`${styles.tagline}`}>
              <p>BAsixsは、ビジネス・アーキテクツが運営する<br></br>「あたりまえ」をアップデートしつづけるメディアです。</p>
            </div>
            <div className={`${styles.linkButton}`}>
              <ButtonCv url="/contact/" label="お問い合わせ" />
            </div>
          </div>
        </div>
        <div className={`${styles.globalNavigation}`}>
          <button
            className={`${styles.menuButton}`}
            id="menu-button"
            type="button"
            aria-label="メニュー"
          >
            <span></span>
          </button>
          <div
            className={`${styles.headerContainer} ${styles.menuPanel}`}
            id="menu-panel"
          >
            <nav aria-label="Global Navigation">
              <ul>
                <li key={"gNavi1"}>
                  <a href="/times/columns/">コラム</a>
                </li>
                <li key={"gNavi2"}>
                  <a href="/services/works/">事例紹介</a>
                </li>
                <li key={"gNavi3"}>
                  <a href="/services/offer/">サービス紹介</a>
                </li>
                <li key={"gNavi4"}>
                  <a href="/tools/materials/">お役立ち資料</a>
                </li>
                <li key={"gNavi5"}>
                  <a class="global-nav-external-link" href="https://www.b-architects.com/" target="_blank" rel="noopener noreferrer">ビジネス・アーキテクツ</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
      {/* NOTE : ハンバーガーメニューの開閉のトリガーです。 */}
      <Script>
        {`
          const menuButton = document.querySelector('#menu-button');
          const menuPanel = document.querySelector('#menu-panel');

          menuButton.addEventListener('click',() => {
            menuButton.classList.toggle('${styles.active}');
            menuPanel.classList.toggle('${styles.active}');
          });
        `}
      </Script>
    </>
  );
};

export default Header;
